<template>
  <div class="order-success">
    <div class="success-detail" v-if="transaction.orderState === 'PAYMENT_SUCCESSFUL'">
      <img :src="require('../assets/images/success-mark.svg')" />
      <h3 class="congrats-text"> Congrats </h3>
      <router-link
        :to="{'path': '/'}"
        replace
        tag="span"
        class="see-coupon"
      > home </router-link>
    </div>
    <div v-if="transaction.orderState==='PAYMENT_FAILURE'" class="success-detail">
      <img :src="require('../assets/images/payment-failed.svg')" style="width: 100%;" />
      <h3 class="congrats-text"> Payment failed </h3>
      <router-link
        :to="{'path': '/'}"
        replace
        tag="span"
        class="see-coupon"
      > home </router-link>
    </div>
    <loadingIcon v-if="loading" />
  </div>
</template>

<script>
import constants from "../utils/constants";
import loadingIcon from "./icons/loadingIcon";
export default {
  name: "OrderSuccess",
  components:{
    loadingIcon
  },
  data() {
    return {
      transaction: {},
      loading: true,
      id:'3668868',
    };
  }, 
  methods: {
    getOrderResult() {
      this.loading = true;
      this.$store.dispatch({type: 'getOrderResult', payload:  this.id}).then((data)=>{
        this.transaction = data
        this.loading = false
      })
      .catch((err)=>{
        console.log(err)
        this.loading = false
      })
    }
  },
  mounted() {
    if(this.$route.query.orderId){
      this.getOrderResult();
    }
  }
};
</script>
<style scoped>
.content-loader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #80c6bf8c;
  z-index: 99;
}

.content-loader img,
.cntntLoad img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.order-success {
  background: #fff;
  position: relative;
  height: 100vh;
}
.success-detail {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  text-align: center;
}
.success-detail .congrats-text {
  margin: 35px 0 20px;
  font-weight: 600;
  font-size: 2.125em;
}
.success-detail .congrats-msg {
  font-size: 1.125em;
  color: #505050;
}
.success-detail .see-coupon {
  display: block;
  border: 1px solid #ff9933;
  width: fit-content;
  margin: 15px auto;
  padding: 8px 40px;
  border-radius: 10px;
  color: #ff9933;
  font-weight: 600;
}
</style>